<template>
    <v-card @click="triggerFileInput" @drop="onDrop" @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true" @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover, 'my-2': true }">
        <v-card-text>
            <v-row class="d-flex flex-column" dense align="center" justify="center">
                <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                    mdi-cloud-upload
                </v-icon>
                <p>
                    {{language.t('FormFields.DragAndDropFile.description')}}
                </p>
            </v-row>

            <!-- Hidden file input -->
            <input type="file" ref="fileInput" style="display: none" @change="handleFileSelect" accept=".csv,.dxf,.log">


            <v-list-item v-if="uploadedFiles.length == 1">
                <v-list-item-content>
                    <v-list-item-title>
                        {{ uploadedFiles[0].name }}
                        <span class="ml-3 text--secondary">
                            {{ (uploadedFiles[0].size / (1024 * 1024)).toFixed(2) }} MB</span>
                    </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                    <v-btn @click.stop="removeFile(uploadedFiles[0].name)" icon>
                        <v-icon> mdi-close-circle </v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

            <v-virtual-scroll v-if="uploadedFiles.length > 1" :items="uploadedFiles" item-height="50">
                <template v-slot:default="{ item }">
                    <v-list-item :key="item.name">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.name }}
                                <span class="ml-3 text--secondary">
                                    {{ (item.size / (1024 * 1024)).toFixed(2) }} MB</span>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-btn @click.stop="removeFile(item.name)" icon>
                                <v-icon> mdi-close-circle </v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-virtual-scroll>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "Upload",
    props: {
        dxffile: File,
        layername: String,
        numfeatures: Number,
    },
    data() {
        return {
            dragover: false,
            uploadedFiles: []
        };
    },
    watch: {
        uploadedFiles(val) {
            this.$emit("fileUpdate", val)
        }
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileSelect(event) {
            for (const file of event.target.files) {
                this.addFile(file);
            }
            this.$refs.fileInput.value = ""
        },
        addFile(file) {
            console.log("addFile")
            console.log(file)
            const isCSV = file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");
            const isDXF = file.name.toLowerCase().endsWith(".dxf");
            const isLOG = file.name.toLowerCase().endsWith(".log");

            // If it's neither CSV, DXF, nor LOG, reject it
            if (!isCSV && !isDXF && !isLOG) {
                console.warn("Only CSV, DXF, or LOG files are allowed.");
                return;
            }

            // If uploading a .log file, remove all other files
            if (isLOG) {
                console.log("Uploading log file")
                this.uploadedFiles = [file]; // Replace all files with only the .log file
                return;
            }

            // Find existing CSV and DXF files
            const csvIndex = this.uploadedFiles.findIndex(f => f.type === "text/csv" || f.name.toLowerCase().endsWith(".csv"));
            const dxfIndex = this.uploadedFiles.findIndex(f => f.name.toLowerCase().endsWith(".dxf"));
            const logIndex = this.uploadedFiles.findIndex(f => f.name.toLowerCase().endsWith(".log"));

            if (logIndex !== -1) {
                console.log("replacing log file")
                this.uploadedFiles = [file]
                return;
            }

            if (isCSV) {
                // If a CSV is already present, replace it
                if (csvIndex !== -1) {
                    this.uploadedFiles.splice(csvIndex, 1);
                }
            } else if (isDXF) {
                // If a DXF is already present, replace it
                if (dxfIndex !== -1) {
                    this.uploadedFiles.splice(dxfIndex, 1);
                }
            }

            // Add the new file
            this.uploadedFiles.push(file);
        },
        removeFile(fileName) {
            // Find the index of the
            const index = this.uploadedFiles.findIndex(
                file => file?.name === fileName
            );
            // If file is in uploaded files remove it
            if (index > -1) this.uploadedFiles.splice(index, 1);
        },
        onDrop(e) {
            this.dragover = false;
            e.preventDefault()

            for (const file of e.dataTransfer.files) {
                this.addFile(file);
            }
        }
    }
};
</script>